// extracted by mini-css-extract-plugin
export default {"quickAccessWrapper":"quick-access_quickAccessWrapper__KH6yZ","activeMenu":"quick-access_activeMenu__Wfp6S"};